module.exports = __webpack_public_path__ + "img/1502044474.44dcbf54.jpg";